<div class="mt-2">
  <div class="row">
    <div class="col-md-6 mt-3 w-100">
      <h4 class="title"><i class="fa fa-folder" aria-hidden="true"></i> {{entityName | translate}}</h4>
    </div>
    <div class="col-md-6 mt-3 content-position-end">
      <div ngbDropdown class="custom-button">
        <button class="btn btn-outline-success custom-button mw-180 font-weight-bold" id="dropdownForm1" ngbDropdownToggle>
          <i class="fa fa-plus" aria-hidden="true"></i> {{ "BUTTON.MORE-ACTIONS" | translate }}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownForm1">
          <a ngbDropdownItem
             (click)="openAddModal(NEW_TEMPLATE)" *ngIf="hasAuthority('own:template:design:new:add')">
            <i class="fa fa-plus"></i> {{"BUTTON.DESIGN-NEW-TEMPLATE"| translate}}
          </a>
          <a ngbDropdownItem
             (click)="openAddModal(UPLOAD_TEMPLATE)" *ngIf="hasAuthority('own:template:upload:add')">
            <i class="fa fa-file"></i> {{ "BUTTON.UPLOAD-TEMPLATE" | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="bg-white-radius">
    <div class="row">
      <div class="col-md-2 custom-mr-17" *ngIf="hasRole(ROLE_SUPERADMIN)">
        <label class="font-weight-bold">{{ "LABEL.PARTNER" | translate }}: </label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fa fa-university"></i></div>
          </div>
          <select class="form-control"
                  [(ngModel)]="partnerIdSelected"
                  (ngModelChange)="reloadTemplate0()">
            <option *ngFor="let partner of partners" [ngValue]="partner.id">{{partner.name | translate}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-3 custom-mr-17" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
        <label class="font-weight-bold">{{ "LABEL.ENTERPRISE" | translate }}:</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fa fa-building" aria-hidden="true"></i></div>
          </div>
          <select class="form-control" [(ngModel)]="enterpriseIdSelected"
                  (ngModelChange)="reloadTemplate1()">
            <option *ngFor="let enterprise of enterprises"
                    [ngValue]="enterprise.id">{{enterprise.name | translate}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-1 custom-mt-24 custom-mr-17 custom-col-md-1"
           *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
        <button type="button"
                class="btn btn-outline-success custom-button"
                (click)="search()">
          <i class="fa fa-search"></i> {{ "BUTTON.SEARCH" | translate }}
        </button>
      </div>
      <div class="col custom-mt-24">
        <div class="custom-control custom-checkbox ml-2">
          <input type="checkbox"
                 id="onlyShowAllCheckbox"
                 class="custom-control-input"
                 [(ngModel)]="showAll"
                 (click)="onlyShowAll($event)">
          <label class="custom-control-label"
                 for="onlyShowAllCheckbox">{{ "LABEL.SHOW-DEFAULT-TEMPLATES" | translate }}</label>
        </div>
      </div>
    </div>
    <!--  </div>-->
    <div class="table-responsive mt-2 mb-2 custom-table-height">
      <table class="table-sm table-bordered">
        <thead>
        <tr>
          <th scope="col" title="#"></th>
          <th scope="col" *ngIf="hasRole(ROLE_SUPERADMIN)" title="{{ 'TABLE.HEADER.OWNER' | translate }}"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.NAME' | translate }}"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.DATE' | translate }}"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.STATE' | translate }}"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.ACTION' | translate }}"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let template of templates; let index=index">
          <td title="#"><b>{{(page.number * 10) + index + 1}}</b></td>
          <td *ngIf="hasRole(ROLE_SUPERADMIN)"
              title="{{ 'TABLE.HEADER.OWNER' | translate }}">{{template._more.enterprisePartnerName}}</td>
          <td title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}">{{template._more.enterpriseName}}</td>
          <td title="{{ 'TABLE.HEADER.NAME' | translate }}">{{template.description}}</td>
          <td title="{{ 'TABLE.HEADER.DATE' | translate }}">{{template.createAt | date: 'dd-MM-yyyy hh:mm:ss'}}</td>
          <td title="{{ 'TABLE.HEADER.STATE' | translate }}">{{template.active ? 'activo' : 'Inactivo'}}</td>
          <td title="{{ 'TABLE.HEADER.ACTION' | translate }}">
            <div class="dropdown">
              <button type="button" class="btn btn-default " id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-ellipsis-v"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <button class="dropdown-item pointer"
                        (click)="openEditModal(template)" *ngIf="hasAuthority('own:template:edit')">
                  <i class="fa fa-pen"></i> {{ "BUTTON.EDIT" | translate }}
                </button>
                <button class="dropdown-item pointer"
                        (click)="openDeleteModal(template)"
                        *ngIf="((hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER) ) || !template.showAll) && hasAuthority('own:template:delete')">
                  <i class="fa fa-trash"></i> {{ "BUTTON.DELETE" | translate }}
                </button>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <nav class="Page navigation pagination-custom">
      <div class="row">
        <div class="col-md-8 mt-1">
          <div class="justify-content-row">
            <span class="mr-1 font-weight-normal">Mostrar </span>
            <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                    (ngModelChange)="loadTemplates(enumPage.First)">
              <option *ngFor="let page of pageNumbers" [value]="page.value"
                      class="font-weight-bold">{{page.value}}</option>
            </select>
            <span class="font-weight-normal"> registros.</span>
          </div>
          <div class="page-total-entries">
            {{ "LABEL.TOTAL-RECORDS" | translate }}
            : {{templates.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
          </div>
        </div>
        <div class="col-md-4">
          <ul class="pagination justify-content-end text-center">
            <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
              <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadTemplates(enumPage.First)"
                 tabindex="-1" aria-disabled="true">
                <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
                {{ "BUTTON.FIRST" | translate }}
              </a>
            </li>
            <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
              <a class="left" (click)="loadTemplates(enumPage.Previous)">
                <i class="fa fa-angle-left" aria-hidden="true"></i></a>
            </li>
            <li
              class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
              <a class="right" (click)="loadTemplates(enumPage.Next)"><i
                class="fa fa-angle-right" aria-hidden="true"></i></a>
            </li>
            <li
              class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}"
              (click)="loadTemplates(enumPage.Last)">
              <a class="next">
                {{ "BUTTON.LAST" | translate }}
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
